"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRMVRMeterDashboardView = void 0;
var React = require("react");
require("./style.scss");
var NewEntryCalendar_1 = require("../TRMVRMeterEntriesView/Modals/NewEntryCalendar");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var Types = require("types");
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
var moment = require("moment-timezone");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var translate_1 = require("utils/translate");
var meterActions = require("@caddigital/sok-reducers/lib/actions/sokosite/current");
var meterEntriesActions = require("@caddigital/sok-reducers/lib/actions/trmvrmeterentries/list");
var dashboardActions = require("@caddigital/sok-reducers/lib/actions/trmvrmeterentries/dashboard");
var text_1 = require("utils/text");
var NotFoundPlaceHolder_1 = require("components/NotFoundPlaceHolder");
var EntryChart_1 = require("./EntryChart");
var options_1 = require("views/SokoSiteViews/TRMVRMeterRemarksView/Modal/options");
var mapStateToProps = function (state, ownProps) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        status: state.sokosite.current.status,
        trmvrMeter: state.sokosite.current.trmvrMeter,
        entries: state.trmvrmeterentries.list,
        selectedLanguage: selectedLanguage,
        dashboard: state.trmvrmeterentries.dashboard,
        pending: state.trmvrmeterentries.dashboard.pending
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    fetchCurrentMeter: function (id) {
        return dispatch(meterActions.fetchRequest(id, true));
    },
    fetchMeterEntries: function (meterUuid, limit) {
        return dispatch(meterEntriesActions.fetchRequest(meterUuid, limit));
    },
    fetchOverviewEntries: function (meterUuid, from) {
        return dispatch(dashboardActions.fetchRequest(meterUuid, from));
    },
    fetchPendingRemarks: function (meterUuid) {
        return dispatch(dashboardActions.fetchPendingRequest(meterUuid));
    },
    clearOverview: function () { return dispatch(dashboardActions.clear()); },
    clearState: function () { return dispatch(meterActions.clear()); }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), react_router_dom_1.withRouter, (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        this.props.fetchCurrentMeter(this.props.match.params.id);
        this.props.fetchMeterEntries(this.props.match.params.id, 8);
        this.props.fetchOverviewEntries(this.props.match.params.id, moment().subtract(1, 'months').format('YYYY-MM-DD'));
        this.props.fetchPendingRemarks(this.props.match.params.id);
    },
    componentWillUnmount: function () {
        this.props.clearState();
        this.props.clearOverview();
    }
}), recompose_1.pure);
var entryRows = function (entries, props) {
    if (!props.selectedLanguage || !props.currentProject || !props.trmvrMeter) {
        return;
    }
    var baseUrl = "/".concat(props.selectedLanguage, "/projects/").concat(props.currentProject.id, "/sokosite/trmvrmeter/").concat(props.trmvrMeter.trmvrmeter_uuid);
    var rows = entries.map(function (e) {
        return (React.createElement("div", { key: e.id, className: 'entry-row' },
            React.createElement(react_router_dom_1.Link, { to: "".concat(baseUrl, "/entries/").concat(e.uuid) }, moment(e.date).format('L'))));
    });
    return (React.createElement(React.Fragment, null,
        rows && rows.length > 0 ? (React.createElement("div", { className: 'entry-rows' }, rows)) : (React.createElement(NotFoundPlaceHolder_1.NotFoundPlaceHolder, { title: 'diaryEntriesView/emptyList/title', message: 'diaryEntriesView/emptyList/message', key: 'no-entries', className: 'no-content' })),
        React.createElement("div", { className: 'more' },
            React.createElement(react_router_dom_1.Link, { to: "".concat(baseUrl, "/entries") }, (0, translation_1.getLocalization)('showMore')))));
};
var pendingRows = function (remarks, props) {
    if (!props.selectedLanguage || !props.currentProject || !props.trmvrMeter) {
        return;
    }
    if (props.dashboard.status === 'FETCHING') {
        return (React.createElement("div", { className: 'trmvrEntry-view' },
            React.createElement("div", { className: 'loading' },
                React.createElement(sok_ui_1.LoadingSpinner, null))));
    }
    var baseUrl = "/".concat(props.selectedLanguage, "/projects/").concat(props.currentProject.id, "/sokosite/trmvrmeter/").concat(props.trmvrMeter.trmvrmeter_uuid);
    var rows = remarks.map(function (e) {
        return (React.createElement(sok_ui_1.Row, { key: e.id },
            React.createElement(sok_ui_1.Column, null, moment(e.must_be_fixed_at).isoWeek()),
            React.createElement(sok_ui_1.Column, null, "".concat(e.target, " ").concat(e.meter_type === 'TRMETER'
                ? (0, options_1.findNameWithId)(e.target, options_1.targetOptions)
                : (0, options_1.findNameWithId)(e.target, options_1.targetOptionsMvr))),
            React.createElement(sok_ui_1.Column, null, moment(e.must_be_fixed_at).format('L'))));
    });
    return (React.createElement(React.Fragment, null,
        rows && rows.length > 0 ? (React.createElement("div", { className: 'pending-table' },
            React.createElement("div", { className: 'pending-table-head' },
                React.createElement(sok_ui_1.Row, null,
                    React.createElement(sok_ui_1.Column, null, (0, translation_1.getLocalization)('trMeter/dashboard/pending/week')),
                    React.createElement(sok_ui_1.Column, null, (0, translation_1.getLocalization)('trMeter/dashboard/pending/target')),
                    React.createElement(sok_ui_1.Column, null, (0, translation_1.getLocalization)('trMeter/dashboard/pending/fixedAt')))),
            React.createElement("div", { className: 'pending-table-body' }, rows))) : (React.createElement(NotFoundPlaceHolder_1.NotFoundPlaceHolder, { title: 'trMeter/dashboard/pending/notFound/title', message: 'trMeter/dashboard/pending/notFound/message', key: 'no-remarks', className: 'no-content' })),
        React.createElement("div", { className: 'more' },
            React.createElement(react_router_dom_1.Link, { to: "".concat(baseUrl, "/remarks") }, (0, translation_1.getLocalization)('showMore')))));
};
exports.TRMVRMeterDashboardView = enhance(function (props) {
    var _a, _b, _c;
    if (props.status === 'FETCHING') {
        return (React.createElement("div", { className: 'trmeter-view' },
            React.createElement("div", { className: 'loading' },
                React.createElement(sok_ui_1.LoadingSpinner, null))));
    }
    else if (props.status === 'FAILED') {
        return (React.createElement("div", { className: 'trmeter-view' },
            React.createElement(NotFoundPlaceHolder_1.NotFoundPlaceHolder, { className: "no-meter", key: "no-meter", title: "diaryEntriesView/emptyList/title", message: "trmeter/dashboard/error/message" })));
    }
    var selectedLanguage = (0, translate_1.getLanguage)();
    var perm = props.currentProject && props.currentProject.perm
        ? props.currentProject.perm
        : 0x00;
    var meterPerm = props.trmvrMeter && props.trmvrMeter.perm ? props.trmvrMeter.perm : 0x00;
    var _d = React.useState(false), show = _d[0], setShow = _d[1];
    var _e = React.useState('prev30'), currentOverview = _e[0], setCurrenOverview = _e[1];
    var _f = React.useState(moment().toDate()), startDate = _f[0], setStartDate = _f[1];
    var openModal = function () { return setShow(true); };
    var closeModal = function () { return setShow(false); };
    var setDate = function (date) { return setStartDate(date); };
    var current = new Date();
    var day = "".concat(current.getDate());
    var year = "".concat(current.getFullYear());
    var monthName = moment().format('MMMM');
    var overviewOptions = [
        {
            key: 'prev30',
            value: moment().subtract(1, 'months').format('YYYY-MM-DD')
        },
        {
            key: 'prev180',
            value: moment().subtract(6, 'months').format('YYYY-MM-DD')
        },
        {
            key: 'prev365',
            value: moment().subtract(12, 'months').format('YYYY-MM-DD')
        }
    ];
    return (React.createElement("div", { className: 'content-wrapper-content' },
        React.createElement("div", { className: 'trmeter-view' },
            React.createElement("main", { className: 'content' },
                React.createElement(sok_ui_1.BreadCrumb, null,
                    props.currentProject ? (React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/projects/").concat(props.currentProject.id) }, props.currentProject.name)) : (React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage) }, "SokoPro")),
                    props.currentProject && (React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/projects/").concat(props.currentProject.id, "/sokosite") }, (0, translation_1.getLocalization)('breadcrumb/sokosite'))),
                    React.createElement("span", null,
                        props.trmvrMeter && props.trmvrMeter.name && (React.createElement(React.Fragment, null, props.trmvrMeter.meterType === 'TRMETER'
                            ? "".concat((0, translation_1.getLocalization)('breadcrumb/trmeter'), ": ").concat(props.trmvrMeter.name)
                            : "".concat((0, translation_1.getLocalization)('breadcrumb/mvrmeter'), ": ").concat(props.trmvrMeter.name))),
                        ((_a = props.trmvrMeter) === null || _a === void 0 ? void 0 : _a.site_number) && (React.createElement(React.Fragment, null, " - ".concat(props.trmvrMeter.site_number),
                            " "))),
                    ((_b = props.trmvrMeter) === null || _b === void 0 ? void 0 : _b.name) && (React.createElement("span", null, "".concat((0, translation_1.getLocalization)('breadcrumb/dashboard'))))),
                React.createElement("div", { className: "card-container" },
                    React.createElement("div", { className: "card-box-entry" },
                        React.createElement("div", { className: "card-box-header" },
                            React.createElement("h2", null, (0, translation_1.getLocalization)('trMeter/dashboard/addNewEntry'))),
                        React.createElement("div", { className: "card-box-entry-content" },
                            React.createElement("div", { className: "entry-header" }, ((_c = props.trmvrMeter) === null || _c === void 0 ? void 0 : _c.name) && (React.createElement("span", null, "".concat((0, translation_1.getLocalization)('breadcrumb/trmeter'))))),
                            React.createElement("div", { className: "entry-name" }, props.trmvrMeter && props.trmvrMeter.name && (React.createElement("span", null, "".concat(props.trmvrMeter.name), "".concat(props.trmvrMeter.site_number
                                ? " / ".concat(props.trmvrMeter.site_number)
                                : '')))),
                            React.createElement("div", { className: "entry-buttons" },
                                React.createElement(sok_ui_1.Button, { className: "date-box" },
                                    React.createElement("p", null,
                                        React.createElement("span", { className: "date-day" }, day),
                                        React.createElement("br", null),
                                        (0, text_1.capitalize)(monthName),
                                        " ",
                                        year)),
                                React.createElement(sok_ui_1.Button, { color: 'base-blue', className: "entry-button", text: (0, translation_1.getLocalization)('trMeter/dashboard/addNewEntry'), disabled: acl.hasGrant(perm, acl.SUPER_ADMIN_GRANT) ||
                                        acl.hasGrant(meterPerm, acl.TRMVRMETER_EMPLOYER_GRANT)
                                        ? false
                                        : true, onClick: function () {
                                        setStartDate(moment().toDate());
                                        openModal();
                                    }, icon: React.createElement(sok_ui_1.Icon, { className: 'fa-plus' }) }),
                                React.createElement(NewEntryCalendar_1.default, __assign({ closeModal: closeModal, show: show, startDate: startDate, setStartDate: setDate }, props))))),
                    React.createElement("div", { className: "card-box-overview" },
                        React.createElement("div", { className: "card-box-header" },
                            React.createElement("h2", null, (0, translation_1.getLocalization)('trMeter/dashboard/overview'))),
                        React.createElement("div", { className: "card-box-content overview-content" },
                            React.createElement("div", { className: "overview-menu-container" },
                                React.createElement(sok_ui_1.Dropdown2, { className: "overview-time-window-menu-dropdown", clickable: true },
                                    React.createElement("div", { className: "overview-time-window-title" },
                                        (0, translation_1.getLocalization)("trMeter/dashboard/overview/".concat(currentOverview)),
                                        React.createElement(sok_ui_1.Icon, { className: 'fa-solid fa-caret-down' })),
                                    React.createElement(sok_ui_1.Dropdown2Menu, { className: "overview-time-window-menu" }, overviewOptions.map(function (option) {
                                        return (React.createElement(sok_ui_1.Dropdown2MenuItem, { key: "".concat(option.key, "-days}"), onClick: function () {
                                                props.fetchOverviewEntries(props.match.params.id, option.value);
                                                setCurrenOverview(option.key);
                                            } },
                                            React.createElement("div", null, (0, translation_1.getLocalization)("trMeter/dashboard/overview/".concat(option.key)))));
                                    })))),
                            React.createElement(EntryChart_1.default, __assign({}, props, { currentTimeWindow: currentOverview, status: props.dashboard.status, overview: props.dashboard.overview, dimensions: {
                                    height: 180,
                                    width: 600
                                } })))),
                    React.createElement("div", { className: "card-box-latest" },
                        React.createElement("div", { className: "card-box-header" },
                            React.createElement("h2", null, (0, translation_1.getLocalization)('trMeter/dashboard/latestEntries'))),
                        React.createElement("div", { className: "card-box-content" }, entryRows(props.entries.list, props))),
                    React.createElement("div", { className: "card-box-remarks" },
                        React.createElement("div", { className: "card-box-header" },
                            React.createElement("h2", null, (0, translation_1.getLocalization)('trMeter/dashboard/pendingRemarks'))),
                        React.createElement("div", { className: "card-box-content" }, pendingRows(props.pending, props))))))));
});
